import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FlightSearchState {
  isLoading: boolean;
  error: boolean;
  isResponseEnd: boolean;
  showModifyBar?: boolean;
  connectionKey?: number;
  searchKey?: string;
}

const initialState: FlightSearchState = {
  isLoading: true,
  error: false,
  isResponseEnd: false,
  showModifyBar: false,
  connectionKey: 0,
  searchKey: undefined,
};

const flightSearchSlice = createSlice({
  name: "flightSearchStatus",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
    setIsResponseEnd: (state, action: PayloadAction<boolean>) => {
      state.isResponseEnd = action.payload;
    },
    resetFlightSearchState: () => initialState,
    toggleModifyBar: (state, action: PayloadAction<boolean>) => {
      state.showModifyBar = action.payload;
    },
    refetch: (state, action) => {
      state.connectionKey = (state.connectionKey || 0) + (action.payload || 0);
      state.searchKey = undefined; // Invalidate cache to force new search
    },
    setSearchKey: (state, action: PayloadAction<string | undefined>) => {
      state.searchKey = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setIsResponseEnd,
  resetFlightSearchState,
  toggleModifyBar,
  refetch,
  setSearchKey,
} = flightSearchSlice.actions;

export default flightSearchSlice;
